import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  AppleAppStoreBlack as AppleAppStore,
  GooglePlay,
} from '@johnlewispartnership/wtr-ingredients/ingredients/Badge/AppBadging';

import { TextLink } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/TextLink';
import Typography from '@johnlewispartnership/wtr-ingredients/dist/foundations/typography';
import styles from './AppLinks.scss';

const getAppIcon = type => {
  switch (type) {
    case 'App Store':
      return <AppleAppStore className={styles.icon} />;
    case 'Google Play':
      return <GooglePlay className={styles.icon} />;
    default:
      return null;
  }
};

const AppLinks = ({ className, data }) => {
  const { links, title } = data;

  return (
    <div className={classNames(className, styles.appLinks)}>
      <Typography element="h3" className={styles.appsSectionTitle}>
        {title}
      </Typography>
      {links.map((link, index) => {
        const { href, popup, title: linkTitle, type } = link;

        const linkProps = {
          'data-actiontype': 'redirect',
          'data-origincomponent': 'footer link',
          'data-shortdescription': `footer link: ${title}: ${linkTitle}`,
          'aria-label': `Find our app on the ${linkTitle}`,
          className: styles.appLink,
          href,
          key: `footer-${linkTitle.toLowerCase()}-soc-${index}`,
          target: popup ? '_blank' : '_self',
          title: linkTitle,
        };

        return (
          <TextLink underline={false} data-testid={type} className={styles.icon} {...linkProps}>
            {getAppIcon(type)}
          </TextLink>
        );
      })}
    </div>
  );
};

AppLinks.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    links: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string,
        popup: PropTypes.bool,
        title: PropTypes.string,
        type: PropTypes.string,
      }),
    ),
    title: PropTypes.string,
  }).isRequired,
};

AppLinks.defaultProps = {
  className: '',
};

AppLinks.displayName = 'AppLinks';

export default AppLinks;
